<template>
  <transition name="fade">
    <div v-if="visible" class="fixed" @click="closePopup">
      <div class="modal-card" @click.stop>
        <div class="icon-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="var(--text-color-red)" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
          </svg>
        </div>
        <h3 style="font-size: 1.25rem; font-weight: 700; color: var(--text-color-dark); margin-bottom: 0.5rem;">
          Información
        </h3>
        <p style="font-size: 14px; color: var(--text-color-light); margin-bottom: 1.5rem; line-height: 1.55;">
          {{ errorMessage }}
        </p>
        <button @click="closePopup" class="main_button-green w-full" style="padding: 10px;">
          Entendido
        </button>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
  errorMessage: String,
});

const emit = defineEmits(['closed']);

const visible = ref(false);

watch(() => props.errorMessage, (newVal) => {
  visible.value = !!newVal;
});

const closePopup = () => {
  visible.value = false;
  emit('closed');
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.modal-card {
  background-color: var(--white);
  padding: 1.75rem;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-xl);
  width: 90%;
  max-width: 400px;
  text-align: center;
  border: 1px solid var(--border-color);
  animation: slideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.icon-header {
  margin-bottom: 0.75rem;
  display: flex;
  justify-content: center;
}

@keyframes slideUp {
  from { transform: translateY(12px) scale(0.98); opacity: 0; }
  to { transform: translateY(0) scale(1); opacity: 1; }
}
</style>
  